export const BoxShadow = {
  Default: "0px 5px 20px rgba(0, 0, 0, 0.05)",
};
